module.exports = __webpack_public_path__ + "static/img/tab2en-Pp1Qq2Rr.01f113b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/tab2en-Pp1Qq2Rr.png
// module id = nwY9
// module chunks = 16